// Schnell ausfüllen: setzt Tipps für die übergebenen (offenen) Spiele nur
// lokal – gespeichert wird erst über die Speichern-Leiste der Tippseite.
// Deshalb braucht es hier keine Bestätigungs-Dialoge.

function QuickTippButtons({ spiele, tipps, setTipps, onHinweis }) {
  const anzahl = spiele.length;

  const setzeAlle = (tippFuerSpiel, hinweis) => {
    if (anzahl === 0) return;
    const neueTipps = { ...tipps };
    spiele.forEach(spiel => {
      neueTipps[spiel.id] = tippFuerSpiel(spiel);
    });
    setTipps(neueTipps);
    if (onHinweis) onHinweis(hinweis);
  };

  const handleFavoriten = () => setzeAlle(
    (spiel) => {
      // Spread negativ = Heimteam Favorit. Ohne Spread gilt der Heimvorteil.
      const heimFavorit = spiel.spread ? spiel.spread < 0 : true;
      return { heimScore: heimFavorit ? 24 : 21, gastScore: heimFavorit ? 21 : 24 };
    },
    `Favoriten eingetragen (${anzahl} Spiele) – noch nicht gespeichert`
  );

  const handleHeimteams = () => setzeAlle(
    () => ({ heimScore: 24, gastScore: 20 }),
    `Heimteams eingetragen (${anzahl} Spiele) – noch nicht gespeichert`
  );

  const handleLeeren = () => setzeAlle(
    () => ({ heimScore: '', gastScore: '' }),
    'Felder geleert – gespeicherte Tipps bleiben, bis du neu speicherst'
  );

  return (
    <div>
      <div className="schnell-tipp__buttons">
        <button type="button" className="chip" onClick={handleFavoriten} title="24:21 für den Favoriten laut Spread">
          🎯 Favoriten gewinnen
        </button>
        <button type="button" className="chip" onClick={handleHeimteams} title="24:20 für alle Heimteams">
          🏠 Heimteams gewinnen
        </button>
        <button type="button" className="chip" onClick={handleLeeren} title="Leert die Felder der offenen Spiele">
          🧹 Felder leeren
        </button>
      </div>
      <p className="schnell-tipp__hinweis">
        Wirkt auf die {anzahl} offenen Spiele dieser Woche. Danach unten auf „Tipps speichern“.
      </p>
    </div>
  );
}

export default QuickTippButtons;
